import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@wordpress/components';
/**
 * A button used when comparing items, if `count` is less than 2 a hoverable tooltip is added with `helpText`.
 *
 * @return { object } -
 */

var CompareButton = function CompareButton(_ref) {
  var className = _ref.className,
      count = _ref.count,
      children = _ref.children,
      disabled = _ref.disabled,
      helpText = _ref.helpText,
      onClick = _ref.onClick;
  return !disabled && count < 2 ? createElement(Tooltip, {
    text: helpText
  }, createElement("span", {
    className: className
  }, createElement(Button, {
    className: "woocommerce-compare-button",
    isDefault: true,
    disabled: true
  }, children))) : createElement(Button, {
    className: classnames('woocommerce-compare-button', className),
    isDefault: true,
    onClick: onClick,
    disabled: disabled
  }, children);
};

CompareButton.propTypes = {
  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * The count of items selected.
   */
  count: PropTypes.number.isRequired,

  /**
   * The button content.
   */
  children: PropTypes.node.isRequired,

  /**
   * Text displayed when hovering over a disabled button.
   */
  helpText: PropTypes.string.isRequired,

  /**
   * The function called when the button is clicked.
   */
  onClick: PropTypes.func.isRequired,

  /**
   * Whether the control is disabled or not.
   */
  disabled: PropTypes.bool
};
export default CompareButton;
//# sourceMappingURL=button.js.map